module.exports = __webpack_public_path__ + "static/media/ER-GUM1_1okRIR8vg1q5uGSMnYia6PpM7rd9KoP32.a0097e52.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/ER-GUM1_1okRIR8vg1q5uGSMnYia6PpM7rd9KoP32
// module id = 632
// module chunks = 0